import axios from 'axios'

export const getPoints = () => {
  return axios.get('point/total')
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getHistoryPoint = () => {
  return axios.get('point/history')
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getVoucherPoint = () => {
  return axios.get('point/voucher')
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const postRedeemPoint = (payload) => {
  return axios.post('point/redeem', payload)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getLeaderboard = () => {
  return axios.get('leaderboard')
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}



// WEBPACK FOOTER //
// ./src/api/andalinpoint.api.js